var exports = {
  "I": "xe533113f--092779--sc_info",
};

module.exports = exports;
